// extracted by mini-css-extract-plugin
export default {"container":"quiz_container__7eLdL","content":"quiz_content__9i8-N","header":"quiz_header__Z4T4w"};